import { render } from "./ConfigurePlatformModal.vue?vue&type=template&id=0efc03a4"
import script from "./ConfigurePlatformModal.vue?vue&type=script&lang=js"
export * from "./ConfigurePlatformModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__